// src/pages/PSHSchool.js
import React, { useState, useEffect } from 'react';

import CategorySection from '../components/CategorySection'; // Import the reusable component
import '../../style/components/FormView.css';  // Ensure correct path to your CSS file

const PSHSchool = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const nonAgriculturalTeachingLinks = [
    { href: "/daArrearsForm", text: "D.A. Arrears" }
  ];


  // Data for the links
  const HighSchool = [
    { href: "hsNewAppointment", text: "New Appointment" },
  ];

  return (

      <div className={`FormView ${isLoading ? 'is-loading' : ''}`}>
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading Resources...</div>
        </div>
      ) : (
        <>
          <h1 className="page-title">Primary, Secondary and Higher Secondary School</h1>

        <div className="section-container">
          {/* Non Agri Teaching Section */}
          <CategorySection title="High School" links={HighSchool} />

          {/* Fading Line Divider */}
          <div className="divider"></div>
    </div>
        </>
      )}
    </div>
  );
};

export default PSHSchool;